import { combineReducers } from 'redux';
import form from './form/reducer';
import loader from './loader/reducer';
import theme from './theme/reducers';
import navigation from './navigation/reducer';
export var rootReducer = combineReducers({
    form: form,
    loader: loader,
    theme: theme,
    navigation: navigation
});
